import React, { useState } from 'react';
import styled from 'styled-components';
import { Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { RESTORE_PASS } from 'api';
import request from 'utils/request';
import PropTypes from 'prop-types';

const InputEmail = styled(Input)`
  &&& {
    border-right-width: 0px !important;
    box-shadow: none;
    border-color: #e5e5e5;
    border-radius: 0px;
    padding-bottom: 11px;
    &:hover {
      border-right-width: 0px !important;
      box-shadow: none;
      border-color: #e5e5e5;
    }
    &:focus {
      border-color: #e5e5e5;
      box-shadow: none;
    }
  }
`;

function ForgotPass({setForgot}) {
  const { t } = useTranslation();
  const [send, setSend] = useState(false);
  const [userNotFind, setUserNotFind] = useState(false);
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const validateMessages = {
    types: {
      email: 'Email is not validate email!',
    },
  };

  const onChange = () => {
    setUserNotFind(false);
  };

  const handleSubmit = async (value) => {
    setLoading(true);
    const responce = await request(`v1${RESTORE_PASS}`, {
      method: 'post',
      data: { email: value.email },
    });
    if (responce) {
      setUserNotFind(true);
      setLoading(false);
    } else {
      setSend(true);
      setValue(value.email);
      setLoading(false);
      setUserNotFind(false);
    }
  };
  return (
    <div className="w-422 flex items-center justify-center flex-col">
      <h1 className="text-36 font-bold">{t('recovery')}</h1>
      <div className="p-0 w-285 text-center m-center mb-20 text-14">
        {t('enterrecoveryMail')}
      </div>
      {send && (
        <div className="bg-white border border-lightGray rounded-lg w-full text-center p-18 mb-18">
          {t('linkSend')} {value} {t('checkMail')}
        </div>
      )}
      {!send ? (
        <div className="bg-white w-full text-center p-30  rounded-lg border border-lightGray">
          <Form onFinish={handleSubmit} validateMessages={validateMessages}>
            <Form.Item
              name={['email']}
              rules={[
                { type: 'email', required: true, message: 'Введите email' },
              ]}
            >
              <InputEmail
                onChange={onChange}
                className="border-t-0 border-r-0 border-l-0  border-lightGray"
                placeholder={t('inputYourEmail')}
              />
            </Form.Item>
            <Form.Item>
              <Button
                loading={loading}
                htmlType="submit"
                className="w-full"
                type="primary"
              >
                {t('sendLinkRecovery')}
              </Button>
            </Form.Item>
          </Form>
          {userNotFind && <div className="text-red">{t('userNotFind')} </div>}
        </div>
      ): <Button onClick={() => {setForgot(false)}} type="primary">{t('auth')}</Button>}
    </div>
  );
}

ForgotPass.propTypes = {};

export default ForgotPass;
